import { render, staticRenderFns } from "./PlugInData.vue?vue&type=template&id=59d004f0&scoped=true"
import script from "./PlugInData.vue?vue&type=script&lang=js"
export * from "./PlugInData.vue?vue&type=script&lang=js"
import style0 from "./PlugInData.vue?vue&type=style&index=0&id=59d004f0&prod&scoped=true&lang=scss"
import style1 from "./PlugInData.vue?vue&type=style&index=1&id=59d004f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d004f0",
  null
  
)

export default component.exports